import { createSxStyles } from "@common/createSxStyles.ts";
import { useTheme } from "@mui/material";
import { sectionOuterPaperPadding } from "./PolicySectionsEditor.tsx";

export const usePolicySectionEditorStyles = () => {
    const theme = useTheme();
    const marginX = sectionOuterPaperPadding - 2.5;
    return createSxStyles({
        actionbar: {
            position: "sticky",
            bottom: 0,
            backgroundColor: theme.customPalette.white,
            paddingY: 1.5,
            marginX: -marginX,
            borderTop: `1px solid ${theme.palette.divider}`,
            zIndex: 1,
            borderRadius: "0 0 20px 20px",
        },
        // Stands in for PolicyRichTextView while an item is empty, so it has to carry that view's flat
        // 14px rather than the input's touch-device bump — otherwise the text resizes on click.
        inlinePlaceholder: {
            color: theme.palette.text.disabled,
            fontSize: theme.typography.pxToRem(14),
        },
    });
};
